// extracted by mini-css-extract-plugin
export default {"wrapper":"snackbar_wrapper__Hzus+","snackbarIcon":"snackbar_snackbarIcon__4+FbA"};